import React from "react";
import { useQuickSightAWSAccounts } from "@/hooks/useAWSAccountsReports";
import AWSReportsTemplate from "@/components/templates/AWSReportsTemplate";
import QuickSightAWSAccountsDashboard from "@/components/organisms/AWSAccountsDashboard";

function AWSAccountsReports() {
  const { embedUrl, loading, error, refetch } = useQuickSightAWSAccounts();

  return (
    <AWSReportsTemplate
      title="AWS Accounts Dashboard"
      loading={loading}
      error={error}
      onRetry={refetch}
      hideFilters={true}
      hideDownload={true}
    >
      <QuickSightAWSAccountsDashboard />
    </AWSReportsTemplate>
  );
}

export default AWSAccountsReports;
